import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('BackLink')(
  css({
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    px: 'xxs',
    pt: ['zero', 'zero', 's'],
  }),
);

themeStyles.addBaseStyles('BackLabel')(
  css({
    ml: 'xs',
    pt: '2px',
  }),
);
export default themeStyles;
